import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { MdMoreVert, MdMoreHoriz } from "react-icons/md";
import { GrDocumentConfig } from "react-icons/gr";
import Divider from '@mui/material/Divider';
import ConfirmDialog from '../confirmBox/confirmDialog';
import { useSelector } from 'react-redux';
import { changeLoadingPhaseStatus } from '../../redux/project/projActions';
import StyledTooltip from '../../shared/toolTip/StyledTooltip';
import { TbSettingsDollar } from 'react-icons/tb';
import ItemPrice from '../../tags/itemPrice';
import StyledMenu from './StyledMenu';

const options = [
  'None',
  'Atria',
  'Callisto',
  'Dione',
  'Ganymede',
  'Hangouts Call',
  'Luna',
  'Oberon',
  'Phobos',
  'Pyxis',
  'Sedna',
  'Titania',
  'Triton',
  'Umbriel',
];

const ITEM_HEIGHT = 48;

export default function OptionMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const loadingPhase = useSelector((state) => state.project.loadingPhase)
  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === 'Instrumentation' ? true : false;
  const [bulkCgDsbl, setbulkCgDsbl] = useState(false)
  const [tagCount, setcount] = useState(0);
  const [openItemPrice , setOpenItemPrice ] = useState(false);
  const [priceOption, setPriceOption] = useState('PRICE');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickDialogOpen = async() => {
    if (await props.bulkConfigTagValidHandler()) {
      //setcount(props.selectedTagsCount.getSelectedRows().length)
      setOpenDialog(true);
    }

  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (loadingPhase?.action === "BULK_TAG_CONFIG" && loadingPhase?.phase === "START") {
      setbulkCgDsbl(true)
    }
    if (loadingPhase?.action === "BULK_TAG_CONFIG" && loadingPhase?.phase === "SUCCESS") {
      setbulkCgDsbl(false)
    }
    if (loadingPhase?.action === "BULK_TAG_CONFIG" && loadingPhase?.phase === "ERROR") {
      setbulkCgDsbl(false)
    }
  }, [loadingPhase])

 // console.log("props.selectedRows", props.selectedRows)

  const handlePriceItemClick = (option) => {
    if(option === 'STATUS') {
      setPriceOption('STATUS');
    } else {
      setPriceOption('PRICE');
    }
    setOpenItemPrice(true);
  }

  return (
    <div>
      <ConfirmDialog
        open={openDialog}
        handleClose={handleDialogClose}
        okBtnLbl="Ok"
        cnclBtnLbl="Cancel"
        dlgTitle="Bulk Configuration"
        //dlgContent={`Only Unconfigured/Copied Tags, will be auto-selected for Bulk Configuration.${tagCount > 150 ? ` First 150 Tags Selected can be configured (Selected Tags count: ${tagCount})` : ""} `}
        //dlgContent={`Only Unconfigured/Copied Tags, will be auto-selected for Bulk Configuration ${tagCount}`}
        // dlgContent={`Only Unconfigured/Copied Tags, will be auto-selected for Bulk Configuration`}
        dlgContent={props.selectedRows > 150  ? `You have selected more than 150 tags, First 150 tags that meets the Bulk Configuration criteria will be automatically selected, Do you want to Proceed?`: `Only Tags that meet the Bulk configuration criteria will be automatically selected.`}
        submitFunction={props.configBulkLine} />

      <div className="reportDropdown">
        <StyledTooltip title="More" placement="bottom" disableInteractive>
          <label>
            <MdMoreVert
              className={props.className}
              style={{ marginBottom: "4px", width: "1.4pc" }}
              onClick={handleClick}
            />{" "}
          </label>
        </StyledTooltip>
      </div>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Divider sx={{ my: 0.5 }} />

        {isInstrumentationTab && (
          <div>
            <MenuItem
              disabled={bulkCgDsbl}
              onClick={() => {
                handleClickDialogOpen();
                handleClose();
              }}
              disableRipple
            >
              <GrDocumentConfig />
              &nbsp; Bulk Config
            </MenuItem>
            
            <MenuItem
              disabled={false}
              onClick={() => {
                props.configBulkDetails();
                handleClose();
              }}
              disableRipple
            >
              <GrDocumentConfig />
              &nbsp; Bulk Config Status
            </MenuItem>
          </div>
        )}

        {!isInstrumentationTab && (
          <div>
            <MenuItem 
              onClick={() => {
                handlePriceItemClick('PRICE')
                handleClose()
              }}
              disableRipple
            >
              <TbSettingsDollar />
              &nbsp; Price Part
            </MenuItem>

            <MenuItem
              onClick={() => {
                handlePriceItemClick('STATUS')
                handleClose()
              }}
              disableRipple
            >
              <TbSettingsDollar />
              &nbsp; Price Part Status
            </MenuItem>

            {/* {wsTabValue !== "Buy Resale" && (
              <MenuItem
                disabled={false}
                onClick={() => {
                  props.configBulkDetails();
                  handleClose();
                }}
                disableRipple
              >
                <GrDocumentConfig />
                &nbsp; Bulk Config Status
              </MenuItem>
            )} */}
          </div>
        )}            
        <Divider sx={{ my: 0.5 }} />
      </StyledMenu>
      
      {
        openItemPrice && 
        <ItemPrice 
          gridApi={props.gridApi} 
          setGridApi={props.setGridApi}
          priceOption={priceOption}
          setOpenItemPrice={setOpenItemPrice}
        />
      }
    </div>
  );
}